// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N7GBw","index":"styles_index__39j49"};